import { render, staticRenderFns } from "./ProductInCategory.vue?vue&type=template&id=0e50a86c&scoped=true"
import script from "./ProductInCategory.vue?vue&type=script&lang=js"
export * from "./ProductInCategory.vue?vue&type=script&lang=js"
import style0 from "./ProductInCategory.vue?vue&type=style&index=0&id=0e50a86c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e50a86c",
  null
  
)

export default component.exports